// extracted by mini-css-extract-plugin
export default {"tableQuickFilters":"TableQuickFilters_tableQuickFilters__3w7J0 custom-scrollbar"};